import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import cs from 'classnames';

import { selectPasswordLength } from 'features/auth/authSelectors';

import { MINIMAL_PASSWORD_LENGTH } from 'constants/uiSettings';

import { ReactComponent as PasswordFrame } from 'assets/icons/passwordFrame.svg';
import { ReactComponent as PasswordKeyhole } from 'assets/icons/passwordKeyhole.svg';
import { ReactComponent as PasswordPerson } from 'assets/icons/passwordPerson.svg';
import { ReactComponent as PasswordStar } from 'assets/icons/passwordStar.svg';

import styles from './PasswordStrength.module.scss';

interface PasswordStrengthProps {
  className?: string;
}

const PasswordStrength: React.FC<PasswordStrengthProps> = ({ className }) => {
  const passwordLength = useSelector(selectPasswordLength);
  const stars = Array(MINIMAL_PASSWORD_LENGTH).fill(0);
  const { t } = useTranslation();

  return (
    <div className={cs(className, styles.container)}>
      <div className={styles.personContainer}>
        <PasswordPerson />
      </div>
      <div className={styles.lockContainer}>
        <div className={styles.lockFrameContainer}>
          <PasswordFrame />
          <div className={styles.lockFrameStars}>
            {stars.map((_, index) => (
              <PasswordStar
                key={index}
                className={cs({ [styles.filled]: index < passwordLength })}
              />
            ))}
          </div>
        </div>
        <div
          className={cs(styles.lockHole, {
            [styles.lockFilled]: passwordLength >= MINIMAL_PASSWORD_LENGTH
          })}
        >
          <PasswordKeyhole />
        </div>
      </div>
      <div className={styles.welcomeText}>
        {t('welcome.message')} <br />
        {t('welcome.workspace')}
      </div>
    </div>
  );
};

export default PasswordStrength;
